import { createApp } from 'vue'
import {
  Lazyload, Toast, Dialog, Search, NavBar, Button, Tag, RadioGroup, Radio,
  Icon, Field, CellGroup, ActionSheet, Tabbar, TabbarItem, Swipe, SwipeItem,
  List, PullRefresh, Empty, Image as VanImage, Cell, Collapse, CollapseItem,
  NoticeBar, Popup, Uploader, Form, Picker, DatetimePicker, Step, Steps,
  Divider, Badge, Switch as VanSwitch, Overlay, Loading, Tab, Tabs,
  CountDown, Card, Skeleton, CheckboxGroup, Checkbox
} from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import './assets/styles/common.scss'

const app = createApp(App)

app.use(Lazyload).use(Toast).use(Dialog).use(Search).use(NavBar).use(Button)
app.use(Tag).use(RadioGroup).use(Radio).use(Icon).use(Field).use(CellGroup)
app.use(ActionSheet).use(Tabbar).use(TabbarItem).use(Swipe).use(SwipeItem)
app.use(List).use(PullRefresh).use(Empty).use(VanImage).use(Cell)
app.use(Collapse).use(CollapseItem).use(NoticeBar).use(Popup).use(Uploader)
app.use(Form).use(Picker).use(DatetimePicker).use(Step).use(Steps)
app.use(Divider).use(Badge).use(VanSwitch).use(Overlay).use(Loading)
app.use(Tab).use(Tabs).use(CountDown).use(Card).use(Skeleton)
app.use(CheckboxGroup).use(Checkbox)

app.use(router)
app.mount('#app')
